import React, { Component } from 'react';
import { withRouter } from 'react-router-dom'
import "react-table/react-table.css";
import couterpart from 'counterpart';

import Card from "react-bootstrap/Card";
import Button from "react-bootstrap/Button";
import WorkOrderUtil from '../utilities/WorkOrderUtil';
import AuthenticationService from '../services/AuthenticationService';
import WorkOrderDataService from '../services/WorkOrderDataService';
import { WO_CHUA_SHIP, WO_DA_SHIP, WO_TOBE_FIXE_ALL, WO_TOBE_FIXE_LOITHO, WO_TOBE_FIXE_LOIXI, WO_TOBE_FIXE_LOI_CATKHAC } from '../constants';

class CardOrderByWorkOrderStatus extends Component {
  constructor () {
    super();
    this.state = {
      count: 0,
      status: 0,
      errorFilter: 0,
      allStatus: []
    };
  }

  componentDidMount () {
    if (this.props.info.subStatus !== undefined){
      if (this.props.info.subStatus === WO_CHUA_SHIP || this.props.info.subStatus === WO_DA_SHIP){
        WorkOrderDataService.countShipWorkOrders(`${this.props.info.subStatus}`).then(data => {
          this.setState({ 
              status: this.props.info.status,
              subStatus: `${this.props.info.subStatus}`,
              errorFilter: 0,
              count:  data
          });
        });
      } else {
        WorkOrderDataService.countByStatusAndErrorCode(`${this.props.info.status}`, `${this.props.info.errorFilter}`).then(data => {
          this.setState({ 
              status: this.props.info.status,
              subStatus: `${this.props.info.subStatus}`,
              errorFilter: `${this.props.info.errorFilter}`,
              count:  data
          });
        });
      }
    } else {
      WorkOrderDataService.countByStatus(`${this.props.info.status}`).then(data => {
        this.setState({ 
            status: this.props.info.status,
            count:  data
        });
      });
    }
  }

  getStatusDescription(status){
    if (this.state.allStatus === undefined || this.state.allStatus === null){
        return status;
    }    
    let istatus = parseInt(status);
    let statusInfo = this.props.allStatus.find(x =>{
      return x.status === istatus;
    });
    if (statusInfo !== undefined){
      return statusInfo.statusDescVn;
    }   
    return status;     
  }

  viewDetails() {
    if (AuthenticationService.isShipping()){
      sessionStorage.removeItem('shipOrders.fromDate')
      sessionStorage.removeItem('shipOrders.fromDate')
      WorkOrderUtil.saveItem('shipOrders.woStatus', this.state.status);
      WorkOrderUtil.saveItem('shipOrders.woSubStatus', this.state.subStatus);
      WorkOrderUtil.saveItem('shipOrders.errorFilter', this.state.errorFilter);
      WorkOrderUtil.saveItem('shipOrders.selectedWoStatusList', JSON.stringify([{
        id: this.state.status,
        name: this.getStatusDescription(this.state.status)
      }]));
      this.props.history.push("/shipOrders?status=" + this.state.status);
      return;
    }

    if (AuthenticationService.isSupervisor()){
      sessionStorage.removeItem('superv.fromDate')
      sessionStorage.removeItem('superv.fromDate')
      WorkOrderUtil.saveItem('superv.woStatus', this.state.status);
      WorkOrderUtil.saveItem('superv.woSubStatus', this.state.subStatus);
      WorkOrderUtil.saveItem('superv.errorFilter', this.state.errorFilter);
      WorkOrderUtil.saveItem('superv.selectedWoStatusList', JSON.stringify([{
        id: this.state.status,
        name: this.getStatusDescription(this.state.status)
      }]));
      this.props.history.push("/super?status=" + this.state.status);
      return;
    }

    if (AuthenticationService.isQuality()){
      WorkOrderUtil.saveItem('qualityprod.woStatus', this.state.status);
      WorkOrderUtil.saveItem('qualityprod.selectedWoStatusList', JSON.stringify([{ id: this.state.status, name: this.getStatusDescription(this.state.status) }]));
      this.props.history.push("/qualityproducts?status=" + this.state.status);
      return;
    }
  }

  render() {
    if (this.props.info === undefined){
      return (<></>);
    }
    let shipSubTitle = '';

    if (this.props.info.errorFilter === WO_TOBE_FIXE_LOIXI){
      shipSubTitle = ' - ' + couterpart.translate('wo_loixi');
    } else if (this.props.info.errorFilter === WO_TOBE_FIXE_LOITHO){
      shipSubTitle = ' - ' + couterpart.translate('wo_loi_tho');
    } else if (this.props.info.errorFilter === WO_TOBE_FIXE_LOI_CATKHAC){
      shipSubTitle = ' - ' + couterpart.translate('wo_loi_catkhac');
    } else if (this.props.info.errorFilter === WO_TOBE_FIXE_ALL){
      shipSubTitle = ' - ' + couterpart.translate('wo_loi_others');
    } else {
      if (this.props.info.subStatus === WO_CHUA_SHIP) {
        shipSubTitle = ' - ' + couterpart.translate('wo_wait_for_ship');
      } else if (this.props.info.subStatus === WO_DA_SHIP) { 
        shipSubTitle =  ' - ' + couterpart.translate('wo_shipped')
      }
    }
    if (this.props.btn === 'no'){
      return (
        <Card className="button-w"  style={{ width: '15rem' }} onClick={this.viewDetails.bind(this)}>
          <Card.Body>
            <Card.Title> { this.getStatusDescription(this.state.status) } { shipSubTitle }</Card.Title>
            <Card.Text>
              { this.state.count }
            </Card.Text>
          </Card.Body>
        </Card>  
      )
    }

    return (
      <Card style={{ width: '18rem' }}>
        <Card.Body>
          <Card.Title> { this.getStatusDescription(this.state.status) } { shipSubTitle }</Card.Title>
          <Card.Text>
            { this.state.count }
          </Card.Text>
          <Button className="myButton" onClick={this.viewDetails.bind(this)}>{ couterpart.translate('wo_goto_details') }</Button>
        </Card.Body>
      </Card>  
    );
    
  }
}

export default withRouter(CardOrderByWorkOrderStatus);